import { lazyWithChunkReload } from "../../shared/lib/chunk-load-recovery";

export const CustomerDashboardPage = lazyWithChunkReload(() =>
  import("./customer-dashboard.main").then((m) => ({ default: m.CustomerDashboardPage }))
);
